// extracted by mini-css-extract-plugin
module.exports = {"fluid":"Carousel_fluid__1ZTSC","images":"Carousel_images__RPJ-A","logo":"Carousel_logo__15Q7V"};